<template>
  <div>
    <b-row class="mt-1">
      <b-col>
        <c-tel-input
          :inputType="`number`"
          v-model="authentication.phone"
          class="m-0"
          :defaultInput="authentication.phone"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <c-input
          inputType="text"
          :inputId="`mail`"
          lableText="Email"
          v-model="authentication.email"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <c-input
          inputType="text"
          :inputId="`username`"
          lableText="User Name"
          v-model="authentication.userName"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <div class="password-input-wrapper">
          <c-input
            :inputType="passwordInputType"
            :inputId="`pwd`"
            lableText="Password"
            v-model="authentication.password"
          />
          <img
            :src="
              passwordInputType === 'password'
                ? require('@/assets/icon/passwordHideIcon.svg')
                : require('@/assets/icon/passwordViewIcon.svg')
            "
            @click="togglePasswordVisibility"
            class="password-toggle-icon"
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <eb-select
          type="text"
          label="lable"
          placeholder="Security Question"
          :options="securityQuestions"
          v-model="authentication.securityQuestions.question"
          :selected="authentication.securityQuestions.question"
        ></eb-select>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <c-input
          inputType="text"
          :inputId="`sqa`"
          lableText="Security Question Answers"
          v-model="authentication.securityQuestions.answer"
        />
      </b-col>
    </b-row>
    <slot name="footer-button" :data="authentication"></slot>
  </div>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import { mapGetters } from "vuex";
export default {
  name: "Authentication",
  data() {
    return {
      passwordInputType: "password",
      securityQuestions: [
        {
          lable: "what is your mother maiden name",
          value: "what is your mother maiden name",
        },
        {
          lable: "what is your first school",
          value: "what is your first school",
        },
        { lable: "your first car model", value: "your first car model" },
      ],
      authentication: {
        phone: "",
        email: "",
        userName: "",
        password: "",
        securityQuestions: {
          answer: "",
          question: {},
        },
      },
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
  },
  mounted() {
    if (this.partnerAllData?.authentication) {
      this.authentication.phone = this.partnerAllData?.authentication?.phone;
      this.authentication.email = this.partnerAllData?.authentication?.email;
      this.authentication.securityQuestions =
        this.partnerAllData?.authentication?.securityQuestions || {};
      this.authentication.userName =
        this.partnerAllData?.authentication?.userName || "";
    }
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}
[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: var(--primary);
  color: white;
}
.sqanswer {
  margin-top: -12px !important;
}
.password-toggle-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.password-input-wrapper {
  position: relative;
}
</style>
